// Color + name legend for the weekly hours bar chart.
import { Box, Typography } from '@mui/material';
import { getProjectColor } from '@/utils/colorUtils';
import { useT } from '@/i18n/useT';
import { collectWeeklyChartLegendProjects } from './weeklyChartLegend';

const WeeklyChartLegend = ({ barData }) => {
  const t = useT();
  const projects = collectWeeklyChartLegendProjects(barData);

  if (!projects.length) return null;

  return (
    <Box
      role="list"
      aria-label={t('dashboard.weeklyChartLegend', 'Projecten in deze week')}
      data-testid="dashboard-week-chart-legend"
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
        mt: 1,
        minWidth: 0,
      }}
    >
      {projects.map(({ name, projectId, colorIndex }) => (
        <Box
          key={name}
          role="listitem"
          data-testid="dashboard-week-chart-legend-item"
          data-project-name={name}
          data-project-id={projectId ?? name}
          data-color-index={colorIndex ?? ''}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            minWidth: 0,
            maxWidth: '100%',
          }}
        >
          <Box
            data-testid="dashboard-week-chart-legend-swatch"
            aria-hidden
            sx={{
              width: 10,
              height: 10,
              borderRadius: 0.5,
              flexShrink: 0,
              bgcolor: getProjectColor(projectId ?? name, colorIndex),
            }}
          />
          <Typography
            variant="caption"
            color="text.secondary"
            noWrap
            title={name}
            sx={{
              minWidth: 0,
              maxWidth: 140,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {name}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default WeeklyChartLegend;
